/*
 * Module handling the logged-in user information
 *
 */

define([
  "marionette",
  "underscore",
  "messaging/messenger",
  "./generalConfig/generalConfigModule",
  "./kbConfig/kbConfigModule",
  "./notifications/notificationsModule",
  "./passwordAdmin/passwordAdminModule",
  "./refreshTokens/refreshTokensModule",
  "./userAdminView",
], function (
  Marionette,
  _,
  Messenger,
  GeneralConfigModule,
  KbConfigModule,
  NotificationsModule,
  PasswordAdminModule,
  RefreshTokensModule,
  UserAdminView,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "userAdmin";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.user = Messenger.reqres.request("user"); //get user model
      this.user.showChangePassword = Messenger.reqres.request("tenant:needsPassword");
      Messenger.onSave(function () {
        console.log("saving user self admin configuration");
        this.user.saveModel();
      }, this);

      this.view = new UserAdminView.userView({ model: this.user });
      //set up all the events on this view, including selecting options in numerous dropdowns
      this._setUpViewEvents();

      //show view
      this.showRegion(this.view);
    },
    _setUpViewEvents: function () {
      this.view.on("change:password", () => this._showChangePasswordModal());
      this.view.on("show", () => this._showGeneralConfig());
      this.view.on("show:generalConfig", () => this._showGeneralConfig());
      this.view.on("show:kbConfig", () => this._showKbConfig());
      this.view.on("show:notifications", () => this._showNotifications());
      this.view.on("show:refreshTokens", () => this._showRefreshTokens());
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:admin:userSelfAdmin",
        function () {
          this.show();
        },
        this,
      );
    },
    _showChangePasswordModal: function () {
      // Even though most of the User Admin is handled using child views, this needs to be
      // a modal because the Password Modal is also called when the user is forced to change
      // their current password.
      Messenger.vent.trigger(
        "show:modal",
        PasswordAdminModule,
        {},
        {},
        {
          title: "user.changePassword",
          closeButton: false,
          closeOnBackgroundClick: false,
          modalWidth: 500,
          trackInteraction: {
            action: "Change Password",
            object: "User Password",
          },
        },
      );
    },
    _showGeneralConfig: function () {
      if (!this.generalConfig) {
        this.generalConfig = this.addSubModule(
          new GeneralConfigModule({
            region: this.view.adminArea,
            user: this.user,
          }),
        );
      }
      this.generalConfig.show();
    },
    _showKbConfig: function () {
      if (!this.kbConfig) {
        this.kbConfig = this.addSubModule(
          new KbConfigModule({
            region: this.view.adminArea,
            user: this.user,
          }),
        );
      }
      this.kbConfig.show();
    },
    _showNotifications: function () {
      if (!this.notifications) {
        this.notifications = this.addSubModule(
          new NotificationsModule({
            region: this.view.adminArea,
            user: this.user,
          }),
        );
      }
      this.notifications.show();
    },
    _showRefreshTokens: function () {
      if (!this.refreshTokens) {
        this.refreshTokens = this.addSubModule(
          new RefreshTokensModule({
            region: this.view.adminArea,
            user: this.user,
          }),
        );
      }
      this.refreshTokens.show();
    },
  });
});
